import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"
@Injectable({
  providedIn: 'root'
})
export class CommercialsService {

  constructor(private http : HttpClient) { }

  commercial(type:any) {
   
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/commercial/air/static-components/"+type,{headers : headers,observe:"response"});
   }


   rateCommercial(type:any) {
   
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/commercial/air/static-components/rate-commercial/"+type,{headers : headers,observe:"response"});
   }
   filterCommercial() {
   
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/commercial/air/static-components/filter-commercial",{headers : headers,observe:"response"});
   }
   savePlan(request:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/commercial/plan",request,{headers : headers,observe:"response"});
    
   }


   updatePlan(plan_name:any,json:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/commercial/plan/"+plan_name+"/AIR",json,{headers : headers,observe:"response"});
   }
  
   getdata(userUID:any) {
    if(!userUID){
      userUID=""
      let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/commercial/plans",{headers : headers,observe:"response"});
    }else{
      let headers = new HttpHeaders();
      return this.http.post(environment.API_URL+"/api/commercial/plans/"+userUID,{headers : headers,observe:"response"});
    }
    
   }
  

   getCommercialType(AIR:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/commercial/type/"+AIR,{headers : headers,observe:"response"});
   }

   getCommercialbyPlanUid(PlanUId:any) {
   
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/commercial/"+PlanUId+"/AIR",{headers : headers,observe:"response"});
   }

   getCommercialbyConfigUid(PlanUId:any,configUid:any) {
   
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/commercial/"+PlanUId+"/AIR/"+configUid,{headers : headers,observe:"response"});
   }
   UpdateCommercialbyConfigUid(PlanUId:any,configUid:any,request:any) {
   
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/commercial/"+PlanUId+"/AIR/"+"config/"+configUid,request,{headers : headers,observe:"response"});
   }


   getFareType() {
   
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/commercial/air/static-components/faretypes",{observe:"response"});
   }
   createHoteCommercial(request:any,id:any){
    let headers = new HttpHeaders();

    if(id===null){
      return this.http.post(environment.API_URL+"/api/hotel-commercial/hotel/plan",request,{observe:"response"});

    }else{
      return this.http.post(environment.API_URL+"/api/hotel-commercial/hotel/user/plan/add/"+id,request,{observe:"response"});

    }
   }
   
   updateHoteCommercial(request:any,planId:any){
    
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/hotel-commercial/hotel/plan/"+planId,request,{observe:"response"});
  
   }
   getHotelCommercial(id:any) {

    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    if(id===null){
      return this.http.get( environment.API_URL+"/api/hotel-commercial/hotel/list/plan",{ observe : "response", params : httpParam,responseType : "json"})  

    }else{
      return this.http.get( environment.API_URL+"/api/hotel-commercial/hotel/list/user/plan/"+id,{ observe : "response", params : httpParam,responseType : "json"})  

    }

   
   }
}
